import React, { FC } from 'react';
import { Card } from 'antd';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import { AddressDisplay } from '../address_display/AddressDisplay';
import Mapbox from '../mapbox/Mapbox';

interface SiteSurveyLocationCardProps {
	location: {
		buyerFacility?: {
			longitude?: number;
			latitude?: number;
			primaryAddress?: object;
		};
	};
}

// Just where the site is: the map and the address. The page header already names the location.
export const SiteSurveyLocationCard: FC<SiteSurveyLocationCardProps> = ({ location }) => {
	const longitude = nullSafeGet('buyerFacility.longitude', location);
	const latitude = nullSafeGet('buyerFacility.latitude', location);

	return (
		// The same materialCard classes as LocationCardDisplay, so it matches the work order page's card.
		<Card className="materialCard" bodyStyle={{ padding: 0 }} style={{ height: '100%' }}>
			{longitude && latitude ? (
				<>
					{/* Mapbox fills its nearest positioned ancestor, so the map gets its own absolutely
					positioned box across the top of the card (as in LocationCardDisplay), and the spacer
					below holds its place so the address sits under the map instead of behind it. */}
					<div className="absolute inset-x-0 top-0 h-[320px]">
						<Mapbox
							longitude={longitude}
							latitude={latitude}
							baseLayerStyle="light"
							zoomLevel={7}
						/>
					</div>
					<div className="h-[320px]" />
				</>
			) : null}
			<div className="materialCard__body">
				<AddressDisplay
					hideCountry={true}
					className="materialCard__supportingText"
					address={nullSafeGet('buyerFacility.primaryAddress', location)}
				/>
			</div>
		</Card>
	);
};
